import { FC } from 'react';
import styled from 'styled-components';
import { BubbleMenu } from '@tiptap/react';
import { InlinePopoverProps } from './types';

const StyledBubbleMenu = styled(BubbleMenu)`
  border: 1px solid ${(props) => props.theme.colors.grey100};
  background-color: white;
  border-radius: 4px;
  padding: 4px;
  box-shadow: 0px 8px 15px -4px ${(props) => props.theme.colors.blackOpacity10};
`;

/**
 * A floating popover that appears when text is selected.
 * It uses the BubbleMenu plugin from TipTap.
 * Under the hood, the plugin uses tippy.js.
 * For more information or if more control is needed, see the documentation:
 *
 * @see {@link https://tiptap.dev/api/extensions/bubble-menu | TipTap BubbleMenu}
 * @see {@link https://atomiks.github.io/tippyjs/v6/ | Tippy.js}
 */
const InlinePopover: FC<InlinePopoverProps> = ({
  children,
  editor,
  width,
  className,
}) => {
  return (
    <StyledBubbleMenu
      className={className}
      editor={editor}
      tippyOptions={{
        duration: 100,
        maxWidth: width,
        offset: [0, 4],
        placement: 'bottom-end', // https://atomiks.github.io/tippyjs/v6/all-props/#placement
      }}
    >
      {children}
    </StyledBubbleMenu>
  );
};

export default InlinePopover;
